"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VNDetailedListItemArea = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Link = _interopRequireDefault(require("@material-ui/core/Link"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    listItem: {
      paddingLeft: 0,
      paddingRight: 0
    },
    outerBox: {
      width: "100%"
    },
    innerBox: {
      display: 'flex',
      justifyContent: 'space-between',
      width: "100%",
      overflowWrap: 'anywhere',
      wordBreak: 'break-all'
    },
    chip: {
      height: 20
    },
    notAvailable: {
      opacity: 0.65
    },
    listItemText: {
      wordBreak: 'break-word'
    },
    bottomModifier: {
      display: 'inline-grid',
      width: "100%",
      gridTemplateColumns: 'max-content auto auto',
      '& div:nth-child(2)': {
        '&::before': {
          content: '"|"',
          position: 'absolute',
          marginLeft: -14
        },
        marginLeft: 20
      },
      '& div:nth-child(3)': {
        justifySelf: 'flex-end'
      }
    },
    leftArea: function leftArea(props) {
      return {
        display: 'flex',
        justifyContent: 'center',
        flex: props.leftAreaRatio || props.leftAreaRatio === 0 ? props.leftAreaRatio : 1.5
      };
    },
    centerArea: function centerArea(props) {
      return {
        display: 'flex',
        flex: getCenterAreaFlexRatio(props),
        '& > div': {
          width: '100%'
        }
      };
    },
    rightArea: function rightArea(props) {
      return {
        display: 'flex',
        flex: props.rightAreaRatio || props.rightAreaRatio === 0 ? props.rightAreaRatio : 2
      };
    }
  };
});
var getCenterAreaFlexRatio = function getCenterAreaFlexRatio(props) {
  var totalRatio = 10;
  if (props.leftAreaRatio || props.leftAreaRatio === 0) {
    totalRatio -= props.leftAreaRatio ? props.leftAreaRatio : 1.5;
  }
  if (props.rightAreaRatio || props.rightAreaRatio === 0) {
    totalRatio -= props.rightAreaRatio ? props.rightAreaRatio : 2;
  }
  return totalRatio;
};

/**
 * Meant to serve as a replacement for VNDetailedListItem as too many customizations
 * were being added to it. Chip modifier, Title, Subtitle, Bottom Left Text and Bottom
 * Link Text are all included in this class, with two areas being available for custom content:
 * leftArea and rightArea. The leftArea and rightArea accept commponents, and you can set their
 * widths via leftAreaRatio and rightAreaRatio, which are percentage based off of a scale to 10.
 * The center area with the default content will take up the rest of the width of the cell.
 *
 * There is also a top area that takes up the entire width of the cell, as well as a bottom area
 * that matches the width of the center area.
 * @param {string} title - The title for the center area
 * @param {string} titleTextVariant - The useTheme based name of the generated theme class to apply instead of default, which is theme.typography.h1
 * @param {subTitle} subTitle - The subtitle for the center area
 * @param {string} bottomModifierText - Modifer text at the bottom left of the item
 * @param {string} bottomLinkText - Modifier text at the bottom and to the right of bottomModiferText
 * @param {Func} onBottomLinkTextClick - (REQUIRED IF bottomLinkText SET) - Called if the user clicks the bottomLinkText
 * @param {Func} click - Called if the user clicks the list item
 * @param {component} leftArea - The left area component content
 * @param {float} leftAreaRatio - The width ratio of the left area, percentage float based to 10
 * @param {component} rightArea - The right area component content
 * @param {float} rightAreaRatio - The width ratio of the right area, percentage float based to 10
 * @param {component} topArea - The top area component content
 * @param {component} bottomArea - The bottom area component content
 */
var VNDetailedListItemArea = function VNDetailedListItemArea(props) {
  var classes = useStyles(props);
  var theme = (0, _styles.useTheme)();
  var displayTopArea = function displayTopArea() {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, props.topArea);
  };
  var displayLeftArea = function displayLeftArea() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.leftArea, props.leftAreaClass)
    }, props.leftArea);
  };
  var displayCenterArea = function displayCenterArea() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.centerArea, classes.centerAreaClass)
    }, /*#__PURE__*/_react.default.createElement(_Box.default, null, props.title && /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
      className: (0, _clsx.default)(classes.listItemText, props.customTitleStyle),
      primary: props.title,
      disableTypography: true,
      style: props.titleTextVariant ? props.titleTextVariant : theme.typography.h1
    }), props.subTitle && /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
      className: classes.listItemText,
      primary: props.subTitle,
      primaryTypographyProps: {
        variant: "subtitle1"
      }
    }), props.eventDate && /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
      className: classes.listItemText,
      primary: props.eventDate,
      primaryTypographyProps: {
        variant: "subtitle1"
      }
    }), props.salesEventText && /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
      className: classes.listItemText,
      primary: props.salesEventText,
      primaryTypographyProps: {
        variant: "subtitle1"
      }
    }), props.expiration && /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
      className: classes.listItemText,
      primary: "Expires: ".concat(props.expiration),
      primaryTypographyProps: {
        variant: "subtitle1"
      },
      style: {
        fontStyle: 'italic'
      }
    }), props.note && /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
      className: classes.listItemText,
      primary: "Note: ".concat(props.note),
      primaryTypographyProps: {
        variant: "subtitle1"
      },
      style: {
        fontStyle: 'italic'
      }
    }), /*#__PURE__*/_react.default.createElement(_Box.default, {
      className: classes.bottomModifier
    }, displayBottomModifierText(), displayBottomLinkText()), /*#__PURE__*/_react.default.createElement(_Box.default, null, displayCenterBottomArea())));
  };
  var displayCenterBottomArea = function displayCenterBottomArea() {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, props.bottomArea);
  };
  var displayRightArea = function displayRightArea() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.rightArea, props.rightAreaClass)
    }, props.rightArea);
  };
  var displayBottomModifierText = function displayBottomModifierText() {
    if (props.bottomModifierText) {
      return /*#__PURE__*/_react.default.createElement(_Box.default, {
        pt: 1
      }, /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
        primary: props.bottomModifierText,
        disableTypography: true,
        style: props.bottomModifierTextVariant ? props.bottomModifierTextVariant : theme.typography.overline
      }));
    }
  };
  var displayBottomLinkText = function displayBottomLinkText() {
    if (props.bottomLinkText) {
      return /*#__PURE__*/_react.default.createElement(_Box.default, {
        pt: 1
      }, /*#__PURE__*/_react.default.createElement(_Link.default, {
        onClick: function onClick(e) {
          // Stop propagation to have Link that is clickable inside
          // of a parent
          e.stopPropagation();
          if (props.onBottomLinkTextClick) {
            props.onBottomLinkTextClick();
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
        primary: props.bottomLinkText,
        primaryTypographyProps: {
          variant: "overline"
        }
      })));
    }
  };

  //#region HANDLERS
  // called when the user clicks the list item
  var handleClick = function handleClick() {
    if (props.click) {
      props.click();
    }
  };
  //#endregion

  /**
   * set the is available class on a list item, which sets the opacity down, does NOT disable it
   */
  var getIsAvailableClass = function getIsAvailableClass() {
    if ('isAvailable' in props && props.isAvailable === false) {
      return classes.notAvailable;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    button: true,
    key: props.text,
    onClick: handleClick,
    className: (0, _clsx.default)(classes.listItem, getIsAvailableClass())
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.outerBox,
    pt: 1,
    pb: 1
  }, displayTopArea(), /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.innerBox
  }, displayLeftArea(), displayCenterArea(), displayRightArea())));
};
exports.VNDetailedListItemArea = VNDetailedListItemArea;